// tslint:disable-next-line:max-line-length

import { Component, Directive, EventEmitter, ElementRef, Renderer, HostListener, Output, Input, OnInit, OnDestroy, ChangeDetectionStrategy } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs/Rx';
import { FileManager } from '../source/fileManager.core';
import { FileManagerOptions } from '../interface/fileManagerOptions.interface';
import { FileUploader } from '../source/fileUploader.core';
import { Utils } from '../source/utils.core';
import { Transfer } from '../source/transfer.core';
import { TransferOptions } from '../interface/transferOptions.interface';
export class FileDropComponent implements OnInit {
public fileHoverStart: EventEmitter<any> = new EventEmitter<any>();
public fileHoverEnd: EventEmitter<any> = new EventEmitter<any>();
public fileAccepted: EventEmitter<FileManager[]> = new EventEmitter<FileManager[]>();
public fileRejected: EventEmitter<Error> = new EventEmitter<Error>();
public progress: EventEmitter<number> = new EventEmitter<number>();
public fileOptions: FileManagerOptions;
public uploader: Transfer;
public maxFiles: number;
public accepts: string;
public imageLoaded = false;
private _limit = -1;
private _files: FileManager[];
private _lastFile$: BehaviorSubject<FileManager> = new BehaviorSubject(null);
private _files$: BehaviorSubject<FileManager[]> = new BehaviorSubject([]);
/**
 * @param {?} element
 * @param {?} renderer
 */
constructor(private element: ElementRef,
private renderer: Renderer) {
        this._files = [];
    }
/**
 * @return {?}
 */
public ngOnInit(): void {
        if (typeof this.maxFiles !== 'undefined') {
            this._limit = this.maxFiles;
        }

        this.uploader.queue$.subscribe((data: FileManager[]) => {
            this.checkClass();
        });

        this._files$.subscribe((data: FileManager[]) => {
            this.imageLoaded = (data.length > 0);
        });
    }
/**
 * @return {?}
 */
public get files(): any {
        let /** @type {?} */ files = this._files$.getValue();
        return files;
    }
/**
 * @return {?}
 */
public get latestFile(): any {
        return Utils.asObservable(this._lastFile$);
    }
/**
 * @param {?} event
 * @return {?}
 */
public onFileHoverStart(event: any): void {
        this.fileHoverStart.emit(event);
    }
/**
 * @param {?} event
 * @return {?}
 */
public onFileHoverEnd(event: any): void {
        this.fileHoverEnd.emit(event);
    }
/**
 * @param {?} event
 * @return {?}
 */
public onFileAccepted(event: any): void {
        if (event.length > 0) {
            this.imageLoaded = true;
        }
        this._files$.next(event);
        this.checkClass();
        this.fileAccepted.emit(event);
    }
/**
 * @param {?} event
 * @return {?}
 */
public onFileRejected(event: any): void {
        this.fileRejected.emit(event);
    }
/**
 * @param {?} event
 * @return {?}
 */
public onProgress(event: number): void {
        this.progress.emit(event);
    }
/**
 * @return {?}
 */
private checkClass(): void {
        (this._files.length > 0) ?
            this.renderer.setElementClass(this.element.nativeElement, 'has-files', true) :
            this.renderer.setElementClass(this.element.nativeElement, 'has-files', false);

        this.cleanUp();
    }
/**
 * @return {?}
 */
private cleanUp(): void {
        let /** @type {?} */ files = this._files$.getValue();
        for (let /** @type {?} */ key in files) {
            if (files.hasOwnProperty(key)) {
                let /** @type {?} */ file = files[key];
                (!file.inQueue) && files.splice(+key, 1);
            }
        }
        (files.length > 0) && this._lastFile$.next(files[files.length - 1]);
        (files.length === 0) && this._lastFile$.next(null);

        this._files$.next(files);
    }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
    selector: 'file-drop',
    template: "<label ng2File2Drop ondragover=\"return false;\" [uploader]=\"uploader\" [fileOptions]=\"fileOptions\" (fileHoverStart)=\"onFileHoverStart($event)\" (fileHoverEnd)=\"onFileHoverEnd($event)\" (fileAccepted)=\"onFileAccepted($event)\" (fileRejected)=\"onFileRejected($event)\"> <img imgPreview src=\"\" [image]=\"latestFile | async\" [class.loaded]=\"imageLoaded\" /> <input ng2File2Select type=\"file\" name=\"file\" multiple accept=\"{{accepts}}\" [uploader]=\"uploader\" [fileOptions]=\"fileOptions\" (fileHoverStart)=\"onFileHoverStart($event)\" (fileHoverEnd)=\"onFileHoverEnd($event)\" (fileAccepted)=\"onFileAccepted($event)\" (fileRejected)=\"onFileRejected($event)\"> </label> ",
    changeDetection: ChangeDetectionStrategy.OnPush,
    styles: [".drop-area { position: relative; display: table; border: 2px dashed dimgray; width: 100%; height: 120px; border-radius: 30px; cursor: pointer; transition: background-color cubic-bezier(0.25, 0.46, 0.45, 0.94) 0.3s, border-color cubic-bezier(0.25, 0.46, 0.45, 0.94) 0.3s, opacity cubic-bezier(0.25, 0.46, 0.45, 0.94) 0.3s; background-color: transparent; background-clip: padding-box; z-index: 1; } .drop-area:after { display: table-cell; content: 'Drop files here or select'; text-align: center; vertical-align: middle; border-radius: 30px; z-index: 2; } .drop-area.drop-enter { background-color: rgba(0, 0, 0, 0.1); border-color: rgba(0, 0, 0, 0.9); } .drop-area.drop-enter:after { content: attr(dropValueText); } .drop-area input { display: none; } .drop-area img, .drop-area .icon { pointer-events: none; } .drop-area img { left: 50%; opacity: 0; max-height: 80%; max-width: 80%; position: absolute; top: 50%; -webkit-transition: all 300ms ease-in; -moz-transition: all 300ms ease-in; -ms-transition: all 300ms ease-in; -o-transition: all 300ms ease-in; transition: all 300ms ease-in; -webkit-transform: translate(-50%, -50%); -moz-transform: translate(-50%, -50%); -ms-transform: translate(-50%, -50%); -o-transform: translate(-50%, -50%); transform: translate(-50%, -50%); z-index: -1; } .drop-area img.loaded { opacity: .7; } "]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: ElementRef, },
{type: Renderer, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'fileHoverStart': [{ type: Output },],
'fileHoverEnd': [{ type: Output },],
'fileAccepted': [{ type: Output },],
'fileRejected': [{ type: Output },],
'progress': [{ type: Output },],
'fileOptions': [{ type: Input },],
'uploader': [{ type: Input },],
'maxFiles': [{ type: Input },],
'accepts': [{ type: Input },],
};
}

function FileDropComponent_tsickle_Closure_declarations() {
/** @type {?} */
FileDropComponent.decorators;
/**
 * @nocollapse
 * @type {?}
 */
FileDropComponent.ctorParameters;
/** @type {?} */
FileDropComponent.propDecorators;
/** @type {?} */
FileDropComponent.prototype.fileHoverStart;
/** @type {?} */
FileDropComponent.prototype.fileHoverEnd;
/** @type {?} */
FileDropComponent.prototype.fileAccepted;
/** @type {?} */
FileDropComponent.prototype.fileRejected;
/** @type {?} */
FileDropComponent.prototype.progress;
/** @type {?} */
FileDropComponent.prototype.fileOptions;
/** @type {?} */
FileDropComponent.prototype.uploader;
/** @type {?} */
FileDropComponent.prototype.maxFiles;
/** @type {?} */
FileDropComponent.prototype.accepts;
/** @type {?} */
FileDropComponent.prototype.imageLoaded;
/** @type {?} */
FileDropComponent.prototype._limit;
/** @type {?} */
FileDropComponent.prototype._files;
/** @type {?} */
FileDropComponent.prototype._lastFile$;
/** @type {?} */
FileDropComponent.prototype._files$;
/** @type {?} */
FileDropComponent.prototype.element;
/** @type {?} */
FileDropComponent.prototype.renderer;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
